<section class="buy-wifi-email text-white">
  <app-error></app-error>
  <div class="modal" id="myModal" style="display: block">
    <div class="modal-dialog medium" [ngClass]="{'marginTop':!enableListDevice}">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="modal-close" data-modal-close="wifi-onboard-switch" (keydown.shift.tab)="keydownEvent($event, 'switchshift');"
            (keydown.enter)="closeSwitchOverlay()" (click)="closeSwitchOverlay()" tabindex="0" id="close-switch" [attr.aria-label]="('close' | translate)">×</button>
          <h4 class="modal-title" id="switch-header" >{{'switch.header' | translate}}</h4>
        </div>
        <div class="modal-body">
          <div class="switch-content-wrapper">
            <p [innerHtml]="'switch.instruction1' | translate"></p>
            <div class="wrap-button switch-buymore-container">
              <button class="btn primary small small-12 switch-buy-more" id="switch-buy-more" (click)="goToBuywifi()" (keydown.Tab)="keydownEvent($event, '#list-device');">{{'wifi.buyMoreAccess' | translate}}</button>
            </div>
          </div>
          <div class="switch-line"></div>
          <div class="switch-device-container">
            <div class="switch-dropdown-link">
              <a id="list-device" role="button" [attr.aria-expanded]="enableListDevice" aria-controls="switch-device-select" href="javascript:void(0)" (click)="listDevice()" (keydown.Tab)="keydownEvent($event, 'switch');"
                tabindex="0" [attr.aria-label]="('switch.linkToShowDevice' | translate)">{{'switch.linkToShowDevice' | translate}}
                <svg class="arrow-icon" >
                  <use xlink:href="#in--arrow-up" href="#in--arrow-up" *ngIf="enableListDevice"></use>
                  <use xlink:href="#in--arrow-down" href="#in--arrow-down" *ngIf="!enableListDevice"></use>
                </svg>
              </a>
            </div>
            <div *ngIf="enableListDevice">
              <div class="switch-desc">
                <p [innerHtml]="'switch.instruction2' | translate:{currentDeviceName: currentDeviceName}"></p>
              </div>

              <div class="dropdown-native white switch-device-select" id="switch-device-select">
                <div class="tool-tip bottom-right small error switch-error" role="alert" *ngIf="showSwitchErrorMessage">
                  <div class="tool-tip-inner">
                    <span>{{'selectDevice' | translate}}</span>
                  </div>
                </div>
                <span class="caret icon-down"></span>
                <label class="title" for="switch-device" [ngClass]="{'top-set':selectedDeviceName !== ''}">{{'deviceDropdown.label' | translate}}
                </label>
                <span class="selected-value">{{selectedDeviceName}}</span>
                <select name="switch-device" id="switch-device" aria-expanded="false" tabindex="0" (change)="onChangeDevice($event.target.value, $event)">
                  <option style="display:none" value="" ></option>
                  <option class="option" [value]="i" *ngFor="let  device of deviceTypeData.devices;let i = index">{{device.name}} ({{device.activatedSince | hoursMinutes}} ago) </option>
                </select>
              </div>
              <div class="wrap-button switch-disconnect">
                <button class="btn secondary medium disconnect" id="connect-anyways" role="button" (click)="connectToWifi()" tabindex="0"
                  (keydown.Tab)="keydownEvent($event, '#close-switch');">{{'switch.disconnect' | translate}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
